import { EmptyMessage, IEmptyMessageProps } from '@h2oai/ui-kit';

export default function EmptyStateMessage(props: IEmptyMessageProps) {
  return <EmptyMessage {...props} styles={{ root: { paddingTop: 64 } }} />;
}
